import React, { useState, useEffect } from 'react';
import './Toast.css';

// Module-level toast state (simple pub/sub)
let _setToast = null;

export function showToast(message, type = 'success') {
  if (_setToast) {
    _setToast({ message, type, id: Date.now() });
  } else {
    console.warn('[Toast] Attempted to show toast before component was mounted:', message);
    // Fallback to console
    console.log(`[Toast ${type.toUpperCase()}] ${message}`);
  }
}

export default function Toast() {
  const [toast, setToast] = useState(null);
  _setToast = setToast;

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), 3000);
    return () => clearTimeout(t);
  }, [toast]);

  if (!toast) return null;
  return (
    <div className={`sam-toast sam-toast-${toast.type}`} role="status" aria-live="polite">
      {toast.message}
    </div>
  );
}
